var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalDetailInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.328,
    height: 26.327,
    viewBox: "0 0 26.328 26.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5579",
    "data-name": "Group 5579",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3853",
    "data-name": "Group 3853",
    transform: "translate(9.059 3.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M-125.562,570.443a4.015,4.015,0,0,1-4.1-4.1v-1.7a4.014,4.014,0,0,1,4.1-4.1,4.015,4.015,0,0,1,4.1,4.1v1.7A4.015,4.015,0,0,1-125.562,570.443Zm0-8.493a2.6,2.6,0,0,0-2.689,2.689v1.7a2.6,2.6,0,0,0,2.689,2.689,2.6,2.6,0,0,0,2.689-2.689v-1.7A2.6,2.6,0,0,0-125.562,561.95Z",
    transform: "translate(129.667 -560.535)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3854",
    "data-name": "Group 3854",
    transform: "translate(5.662 14.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-120.663,586.037h-1.415v-2.831c0-1.913-3.949-3.256-6.086-3.256s-6.087,1.342-6.087,3.256v2.831h-1.415v-2.831c0-3.067,4.883-4.671,7.5-4.671s7.5,1.6,7.5,4.671Z",
    transform: "translate(135.667 -578.535)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M-132.5,579.862A13.178,13.178,0,0,1-145.667,566.7,13.178,13.178,0,0,1-132.5,553.535,13.179,13.179,0,0,1-119.339,566.7,13.179,13.179,0,0,1-132.5,579.862Zm0-24.912A11.762,11.762,0,0,0-144.252,566.7,11.761,11.761,0,0,0-132.5,578.447,11.762,11.762,0,0,0-120.755,566.7,11.762,11.762,0,0,0-132.5,554.95Z",
    transform: "translate(145.667 -553.535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailInactive);
export default __webpack_public_path__ + "static/media/personal-detail-inactive.d10097471f6e8fe1557b70a9935601d3.svg";
export { ForwardRef as ReactComponent };